<section id="secao-arquivos" *ngIf="arquivos.length > 0">
  <div class="container">
    <div class="titulo-arquivos">
      <h3>Arquivos para Baixar</h3>
    </div>

    <div class="table-responsive">
      <table class="table tabela-arquivos">
        <thead>
          <tr>
            <th>Arquivo</th>
            <th>Descri&ccedil;&atilde;o</th>
            <th>Download</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let arquivo of arquivos">
            <td>{{ arquivo.nome }}</td>
            <td>{{ arquivo.descricao }}</td>
            <td>
              <a
                [href]="getDownloadUrl(arquivo)"
                target="_blank"
                class="btn-download"
              >
                <span class="material-icons icone-download">file_download</span>
                Baixar
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</section>
